import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import * as signalR from '@microsoft/signalr';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  public hubConnection: signalR.HubConnection;
  private reconnectTimer: any;
  private isStarting: boolean = false;

  constructor() {}

  public initialize() {
    if (!this.hubConnection) {
      this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(environment.API_URL)
      .withAutomaticReconnect()
      .build();

      this.hubConnection.serverTimeoutInMilliseconds = 120000;
      this.hubConnection.keepAliveIntervalInMilliseconds = 30000;
      this.hubConnection.onclose(() => this.scheduleReconnect());
      this.hubConnection.onreconnecting(() => this.clearReconnectTimer());
      this.hubConnection.onreconnected(() => this.clearReconnectTimer());
    }

    this.startConnection();

  }

  public getDataBySignalR(job): Observable<any> {
    const obs = new Observable((observe) => {
      if (!this.hubConnection) {
        this.initialize();
      }
      const handler = (data) => {
        observe.next(data);
      };
      this.hubConnection.on(job, handler);
      return () => this.hubConnection.off(job, handler);
    });

    return obs;
  }

  public getDataBySignalRArray(job): Observable<any> {
    const obs = new Observable((observe) => {
      if (!this.hubConnection) {
        this.initialize();
      }
      const handler = (...data) => {
        observe.next(data);
      };
      this.hubConnection.on(job, handler);
      return () => this.hubConnection.off(job, handler);
    });

    return obs;
  }

  public getNotificationsBySignalR(job): Observable<any> {
    const obs = new Observable((observe) => {
      if (!this.hubConnection) {
        this.initialize();
      }
      const handler = (data) => {
        observe.next(data);
      };
      this.hubConnection.on(job, handler);
      return () => this.hubConnection.off(job, handler);
    });

    return obs;
  }

  private startConnection() {
    if (!this.hubConnection ||
        this.isStarting ||
        this.hubConnection.state !== signalR.HubConnectionState.Disconnected) {
      return;
    }

    this.isStarting = true;
    this.hubConnection
      .start()
      .then(() => {
        this.isStarting = false;
        this.clearReconnectTimer();
      })
      .catch(() => {
        this.isStarting = false;
        this.scheduleReconnect();
      });
  }

  private scheduleReconnect() {
    if (this.reconnectTimer) {
      return;
    }

    this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = undefined;
      this.startConnection();
    }, 5000);
  }

  private clearReconnectTimer() {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = undefined;
    }
  }
}
